import { Application } from 'app/Application'

// Application singleton that can be imported anywhere
export default new Application()



// WEBPACK FOOTER //
// ./src/scripts/containers/app.js